import React, { useCallback, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import MenuItemsTable from '../MenuItemsTable/MenuItemsTable';
import ProductGroupDetailsModal from '../MenuItemDetailsDialog/MenuItemDetailsDialog';
import AssignmentModal from '../AssignmentModal/AssignmentModal';
import ProductGroupTranslationModal from '../ProductGroupTranslation/ProductGroupTranslationModal';
import {
  assignUnassignMenuItems,
  clearMenuItems,
  clearProductGroups,
  getCategories,
  getGroups,
  getGroupsCatalog,
  getMenuItem,
  getMenuItemsCatalog,
  getMenuItemsFiltered,
  getMenuItemsToValidate,
} from '../../redux/actions/platformsActions';
import {
  selectMenuItemsName,
  selectProductGroupsName,
} from '../../redux/selectors/platformSelector';
import {
  ableAssignmentButton,
  disableAssignmentButton,
} from '../../redux/actions/utilsActions';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import { getProductGroupTranslation } from '../../redux/actions/productGroupTranslation';
import AssignmentModalRestaurantsProducts from '../AssignmentModalRestaurantsProducts/components/AssignmentModalRestaurantsProducts';
import { useTranslation } from 'react-i18next';
import { actionListener } from '../../utils/helpers';
import { SET_SELECTED_LANGUAGE } from '../../redux/action-types/app-types';
import store from '../../redux/store';

interface OHTIProps {
  restaurantId?: number;
}

const ProductGroupsTab = ({ restaurantId = 0 }: OHTIProps) => {
  const { t } = useTranslation();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const categories = useSelector(
    (state: RootStateOrAny) => state.PlatformsReducer.categories,
  );
  const totalPlatforms = useSelector(
    (state: RootStateOrAny) => state.PlatformsReducer.total,
  );
  const pagePlatforms = useSelector(
    (state: RootStateOrAny) => state.PlatformsReducer.page,
  );
  const groupsAll = useSelector(
    (state: RootStateOrAny) => state.PlatformsReducer.groups,
  );
  const itemsAll = useSelector(
    (state: RootStateOrAny) => state.PlatformsReducer.items,
  );
  const openAssignmentRestaurantsProducts = useSelector(
    (state: RootStateOrAny) =>
      state.UtilsReducers.openAssignmentRestaurantsProducts,
  );
  const groupsCatalog = useSelector((state: RootStateOrAny) =>
    selectProductGroupsName(state),
  );
  const itemsCatalog = useSelector((state: RootStateOrAny) =>
    selectMenuItemsName(state),
  );
  const [openDetails, setOpenDetails] = useState<boolean>(false);
  const [OpenProductGroupTranslations, setOpenProductGroupTranslations] =
    useState(false);
  const [GroupSelected, setGroupSelected] = useState(null);

  const searchReduxObject = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.searchObject,
  );
  const dispatch: any = useDispatch();
  const [groups, setGroups] = useState({});

  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  useEffect(() => {
    const unsubscribeChangeTranslation = actionListener(
      store,
      SET_SELECTED_LANGUAGE,
      function () {
        if (selectedBrand) {
          const objSearch = { brand: selectedBrand, limit: 100 };
          if (restaurantId) {
            objSearch['restaurantId'] = restaurantId;
          }
          clearSelectedEquipments(true);
          dispatch(clearProductGroups());
          dispatch(getCategories(objSearch));
          dispatch(getGroupsCatalog(selectedBrand, '', restaurantId));
        }
      },
    );

    if (selectedBrand && !openAssignmentRestaurantsProducts) {
      const objSearch = { brand: selectedBrand, limit: 100 };
      if (restaurantId) {
        objSearch['restaurantId'] = restaurantId;
      }
      dispatch(getCategories(objSearch));
      dispatch(getGroupsCatalog(selectedBrand, '', restaurantId));
    }
    return () => {
      unsubscribeChangeTranslation();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBrand, openAssignmentRestaurantsProducts]);

  useEffect(() => {
    if (groupsAll.length) {
      setGroups(
        groupsAll.reduce((ac, g) => {
          g.items = itemsAll.filter(
            i =>
              i.productGroupId === g.productGroupId &&
              i.categoryId === g.categoryId,
          );
          if (ac[g.categoryId]) {
            ac[g.categoryId].push(g);
          } else {
            ac[g.categoryId] = [g];
          }
          return ac;
        }, {}),
      );
    } else {
      setGroups({});
    }
  }, [groupsAll, itemsAll]);

  const [searchObjectPrev, setSearchObjectPrev] = useState<any>({
    group: '',
    item: '',
  });
  const [searchObject, setSearchObject] = useState<any>({
    group: '',
    item: '',
  });
  const handleChangeAutocomplete = (name: string, value: any) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [name]: value ? value : '',
    });
  };
  const [itemInput, setItemInput] = useState<string>('');
  const [timer, setTimer] = useState<any>(null);
  const callBackFunctionItems = useCallback(
    value => {
      clearTimeout(timer);
      if (itemInput !== value && value.length > 2) {
        setItemInput(value);
        setTimer(
          setTimeout(
            () =>
              dispatch(getMenuItemsCatalog(selectedBrand, value, restaurantId)),
            500,
          ),
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timer, setItemInput, setTimer],
  );
  const [groupInput, setGroupInput] = useState<string>('');
  const [timerGroup, setTimerGroup] = useState<any>(null);
  const callBackFunctionGroups = useCallback(
    value => {
      clearTimeout(timerGroup);
      if ((groupInput !== value && value.length > 2) || value === '') {
        setGroupInput(value);
        setTimerGroup(
          setTimeout(
            () =>
              dispatch(getGroupsCatalog(selectedBrand, value, restaurantId)),
            500,
          ),
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timerGroup, groupInput, selectedBrand],
  );
  const handleInputChangeAutocomplete = (name: string, value: any) => {
    switch (name) {
      case 'item':
        callBackFunctionItems(value);
        break;
      case 'group':
        callBackFunctionGroups(value);
        break;
      default:
        break;
    }
    if (name === 'item') {
      callBackFunctionItems(value);
    }
  };

  const handleApplyButton = () => {
    setClearFlag(true);
    setSearchObject({ ...searchObjectPrev });
    const objSearch = {
      productGroupId: searchObjectPrev.group?.productGroupId,
      menuItem: searchObjectPrev.item?.id,
    };
    if (restaurantId) {
      objSearch['restaurantId'] = restaurantId;
    }
    dispatch(
      getCategories({
        ...searchReduxObject,
        brand: selectedBrand,
        ...objSearch,
        limit: 100,
      }),
    );
    dispatch(clearProductGroups());
    if (
      objSearch.productGroupId ||
      objSearch.menuItem ||
      searchReduxObject.countries ||
      searchReduxObject.regions
    ) {
      dispatch(clearMenuItems());
    }
  };

  const loadMorePlatforms = () => {
    const objSearch = {
      productGroupId: searchObjectPrev.group?.productGroupId,
      menuItem: searchObjectPrev.item?.id,
    };
    if (restaurantId) {
      objSearch['restaurantId'] = restaurantId;
    }
    dispatch(
      getCategories({
        ...searchReduxObject,
        brand: selectedBrand,
        ...objSearch,
        limit: 100,
        page: pagePlatforms + 1,
      }),
    );
  };

  const loadMoreGroups = (categoryId, page) => () => {
    const objSearch = {
      productGroupId: searchObjectPrev.group?.productGroupId,
      menuItem: searchObjectPrev.item?.id,
    };
    if (restaurantId) {
      objSearch['restaurantId'] = restaurantId;
    }
    dispatch(
      getGroups(
        {
          ...searchReduxObject,
          brand: selectedBrand,
          ...objSearch,
          limit: 100,
          page: page + 1,
        },
        categoryId,
      ),
    );
  };

  const loadMoreItems = (categoryId, productGroupId, page) => () => {
    const objSearch = {
      categoryId,
      productGroupId: productGroupId,
      menuItem: searchObjectPrev.item?.id,
    };
    if (restaurantId) {
      objSearch['restaurantId'] = restaurantId;
    }
    dispatch(
      getMenuItemsFiltered({
        ...searchReduxObject,
        ...objSearch,
        limit: 100,
        page: page + 1,
        brand: selectedBrand,
      }),
    );
  };

  const showDetailProduct =
    (categoryId, productGroupId, itemId) => async () => {
      await dispatch(
        getMenuItem(categoryId, productGroupId, itemId, selectedBrand),
      );
      setOpenDetails(true);
    };

  const showProductGroupTranslations = (category, group) => async () => {
    setGroupSelected(group.productGroupId);
    getProductGroupTranslation(
      group.productGroupId,
      selectedBrand,
    )(dispatch).then(response => {
      if (response.status < 300) {
        setOpenProductGroupTranslations(true);
      }
    });
  };
  const handleClose = () => {
    setOpenProductGroupTranslations(false);
  };

  const fetchGroups = id => {
    const objSearch = {
      productGroupId: searchObject.group?.productGroupId,
      menuItem: searchObject.item?.id,
    };
    if (restaurantId) {
      objSearch['restaurantId'] = restaurantId;
    }
    dispatch(
      getGroups(
        {
          brand: selectedBrand,
          limit: 100,
          ...searchReduxObject,
          ...objSearch,
        },
        id,
      ),
    );
  };

  const fetchItems = (idGroup, idCategory) => {
    const objSearch = {
      productGroupId: searchObject.group?.productGroupId || idGroup,
      menuItem: searchObject.item?.id,
      categoryId: searchObject?.categoryId || idCategory,
    };
    if (restaurantId) {
      objSearch['restaurantId'] = restaurantId;
    }
    dispatch(
      getMenuItemsFiltered({
        ...searchReduxObject,
        ...objSearch,
        limit: 100,
        brand: selectedBrand,
      }),
    );
  };
  useEffect(() => {
    return () => {
      dispatch(disableAssignmentButton());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [itemsSelected, setItemsSelected] = useState({
    categories: [],
    groups: [],
    menu_items: [],
  });

  const [clearFlag, setClearFlag] = useState(false);

  const clearSelectedEquipments = flag => {
    setClearFlag(flag);
  };

  /**
   * We validate selected items are less than 50
   * 
   * @param selectedRows 
   * @returns boolean
   */
  const validateItems = async selectedRows => {
    let countItems = 0;

    if (selectedRows.categories?.length) {
      let response = selectedRows.categories.map(category =>
        dispatch(getMenuItemsToValidate(category, searchObject?.group?.productGroupId || 0, selectedBrand, searchReduxObject.countries, searchReduxObject.regions, searchObject?.item?.id))
      );

      response = await Promise.all(response);

      for (let category_menu_items of response) {
        countItems += category_menu_items?.menus?.length ? category_menu_items?.menus?.length : 0;
      }
    }

    if (selectedRows.groups?.length) {
      let response = selectedRows.groups.map(group =>
        dispatch(getMenuItemsToValidate(group.categoryId, searchObject?.group?.productGroupId || group.groupId, selectedBrand, searchReduxObject.countries, searchReduxObject.regions, searchObject?.item?.id))
      );

      response = await Promise.all(response);

      for (let category_menu_items of response) {
        countItems += category_menu_items?.menus?.length ? category_menu_items?.menus?.length : 0;
      }
    }

    countItems += selectedRows.menu_items?.length ? selectedRows.menu_items?.length : 0;

    if (countItems > 50) {
      dispatch(snackbarShowMessage(t('productGroups.limitexceded')));
      return false;
    }

    return true;
  }

  const checkSelected = async selectedRows => {
    if (
      (selectedRows.categories?.length ||
        selectedRows.groups?.length ||
        selectedRows.menu_items?.length) &&
      thisUser.hasAssignMenuItems &&
      await validateItems(selectedRows)
    ) {
      setItemsSelected({ ...selectedRows });
      dispatch(ableAssignmentButton());
    } else {
      if (!restaurantId) {
        dispatch(disableAssignmentButton());
      }
    }
  };

  useEffect(() => {
    if (restaurantId && thisUser.hasAssignMenuItems) {
      dispatch(ableAssignmentButton());
    }
  }, [restaurantId]);

  //assign: boolean
  //reportingUnit: Number
  //restaurants: array[]
  const assignUnassignToRestaurants = async (
    assign,
    reportingUnit,
    restaurants,
  ) => {
    const objToAssign = {
      reporting_unit: reportingUnit,
      restaurants,
      assign,
      brand: selectedBrand,
    };

    if (searchObject?.item?.id) {
      objToAssign['menu_items'] = [searchObject.item.id];
    }
    else {
      if (itemsSelected.categories?.length) {
        objToAssign['categories'] = itemsSelected.categories.map(category =>
          Number(category),
        );
      }

      if (itemsSelected.groups?.length) {
        objToAssign['groups'] = itemsSelected.groups;
      }

      if (itemsSelected.menu_items?.length) {
        objToAssign['menu_items'] = itemsSelected.menu_items;
      }
    }

    if (searchReduxObject.regions) {
      objToAssign['regions'] = searchReduxObject.regions
        .replace(/[\[\]\%22\"]/g, '')
        .split(',');
    }
    if (searchReduxObject.countries) {
      objToAssign['countries'] = JSON.parse(searchReduxObject.countries);
    }
    const response: any = await dispatch(assignUnassignMenuItems(objToAssign));
    if (response?.status < 300) {
      dispatch(snackbarShowMessage(response.data.message));
    } else {
      dispatch(
        snackbarShowMessage(
          assign
            ? t('productGroups.error.assign')
            : t('productGroups.error.unassign'),
        ),
      );
    }
    clearSelectedEquipments(true);
  };

  return (
    <div>
      <div>
        <>
          <MenuItemsTable
            categories={categories}
            groups={groups}
            showDetailProduct={showDetailProduct}
            searchObjectPrev={searchObjectPrev}
            handleInputChangeAutocomplete={handleInputChangeAutocomplete}
            handleChangeAutocomplete={handleChangeAutocomplete}
            handleApplyButton={handleApplyButton}
            fetchItems={fetchItems}
            groupsCatalog={groupsCatalog}
            itemsCatalog={itemsCatalog}
            fetchGroups={fetchGroups}
            totalPlatforms={totalPlatforms}
            loadMorePlatforms={loadMorePlatforms}
            loadMoreGroups={loadMoreGroups}
            loadMoreItems={loadMoreItems}
            handleApply={handleApplyButton}
            checkSelected={checkSelected}
            clearFlag={clearFlag}
            clearSelectedEquipments={clearSelectedEquipments}
            showProductGroupTranslations={showProductGroupTranslations}
            restaurantId={restaurantId}
          />
          {openDetails && (
            <ProductGroupDetailsModal
              open={openDetails}
              setOpen={setOpenDetails}
              readOnly={!thisUser.hasViewMenuItemListAndDetails}
            />
          )}
          <AssignmentModal
            assignUnassignToRestaurants={assignUnassignToRestaurants}
          />
          {openAssignmentRestaurantsProducts && (
            <AssignmentModalRestaurantsProducts
              open={openAssignmentRestaurantsProducts}
              restaurantId={restaurantId}
              resetPlatforms={handleApplyButton}
            />
          )}
          <ProductGroupTranslationModal
            OpenProductGroupTranslations={OpenProductGroupTranslations}
            handleClose={handleClose}
            GroupSelected={GroupSelected}
          />
        </>
      </div>
    </div>
  );
};

export default ProductGroupsTab;
